export default __webpack_public_path__ + "static/media/menusifu-logo.104cb3cb.png";